import React from 'react';
import ReactDOM from 'react-dom';
import { Loop } from './ui/views';

ReactDOM.render(<Loop />, document.getElementById('root'));
